import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _toConsumableArray from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties2 from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { useContext, useState, useCallback, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTable, { ReactTableDefaults } from 'react-table';
import _ from 'lodash';
import { LocaleService, TranslatorContext, sortWithLocale } from '@jutro/locale';
import { intlMessageShape } from '@jutro/prop-types';
import { useBreakpoint } from '@jutro/layout';
import cx from 'classnames';
import { TransitionGroup } from 'react-transition-group';
import { Chevron, AnimationGroup, getKeyPressHandler, RadioButton, CheckboxField } from '@jutro/components';
import { logDeprecationMessage, uniqueInnerId } from '@jutro/platform';
import { error, warning } from '@jutro/logger';
import { Pagination } from './Pagination/Pagination';
import { SHOW_ALL_PAGES } from './Pagination/PageSizes';
import { TableBar } from './TableBar';
import { defaultColumnFilter } from './helper';
import { useExpansion } from './state/expansion/useExpansion';
import { useSelection } from './state/selection/useSelection';
import { useConfig } from './state/config/useConfig';
import { useAsync } from './state/async/useAsync';
import { useAccessibilityProps } from './accessibility/useAccessibilityProps';
import { TableContext } from './TableContext';
import { RadioColumn } from './columns/RadioColumn';
import { ActionColumn } from './columns/ActionColumn';
import { messages } from './DataTable.messages';
import appConfig from 'app-config';
import styles from "./DataTable.module.css";
import 'react-table/react-table.css';
var nonConfigurableColumns = [RadioColumn, ActionColumn];
var textAlignMapping = {
  left: styles.textLeft,
  right: styles.textRight
};

var expanderDefaults = _objectSpread({}, ReactTableDefaults.expanderDefaults, {
  width: 28
});

var AnimatedTrGroupComponent = function AnimatedTrGroupComponent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties2(_ref, ["children"]);

  return React.createElement(ReactTableDefaults.TrGroupComponent, props, React.createElement(TransitionGroup, {
    component: null
  }, children));
};

var transitionGroupProps = ['onExited', 'in', 'appear', 'enter', 'exit'];

var AnimationResistantTrComponent = function AnimationResistantTrComponent(_ref2) {
  var hasActions = _ref2.hasActions,
      props = _objectWithoutProperties2(_ref2, ["hasActions"]);

  var a11yProps = {};

  if (hasActions) {
    a11yProps.tabIndex = 0;
    a11yProps.role = 'button';
    a11yProps['aria-label'] = 'row';
  }

  return React.createElement(ReactTableDefaults.TrComponent, _extends({}, a11yProps, _.omit(props, transitionGroupProps)));
};

var splitHeaderText = function splitHeaderText(text) {
  return React.createElement("span", {
    className: styles.headerMultiline
  }, text);
};

var renderNull = function renderNull() {
  return null;
};

var ignoredClickTargets = ['INPUT', 'BUTTON', 'A', 'LABEL', 'SELECT', 'I'];

var handleNestedClick = function handleNestedClick(event, callback) {
  var currentTarget = event.target;

  if (currentTarget && _includesInstanceProperty(ignoredClickTargets).call(ignoredClickTargets, currentTarget.tagName)) {
    return;
  }

  callback(event);
};

var isEnabledColumn = function isEnabledColumn() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _config$enabled;

  return (_config$enabled = config.enabled) !== null && _config$enabled !== void 0 ? _config$enabled : true;
};

var findById = function findById(id) {
  return function (_ref3) {
    var configId = _ref3.id;
    return id === configId;
  };
};

var orderColumnsUsingConfig = function orderColumnsUsingConfig(config) {
  return function (columnA, columnB) {
    var aInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnA.props.id));

    var bInitialIndex = _findIndexInstanceProperty(config).call(config, findById(columnB.props.id));

    if (aInitialIndex === -1 || bInitialIndex === -1) {
      return 0;
    }

    return aInitialIndex - bInitialIndex;
  };
};

var getAsyncParams = function getAsyncParams(params) {
  return _.pick(params, ['page', 'pageSize', 'sorted', 'filterValue']);
};

var dataTableConfigColumnsShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired
}));
var dataTableConfigColumnsSortedShape = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  desc: PropTypes.bool.isRequired
}));
var dataTableConfigShape = PropTypes.shape({
  editedRow: PropTypes.number,
  columns: dataTableConfigColumnsShape,
  filterValue: PropTypes.string,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  sorted: dataTableConfigColumnsSortedShape
});
var rowIdShape = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
var dataTablePropTypes = {
  id: PropTypes.string.isRequired,
  showSearch: PropTypes.bool,
  showPagination: PropTypes.bool,
  config: dataTableConfigShape,
  defaultConfig: dataTableConfigShape,
  onConfigChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  data: PropTypes.arrayOf(PropTypes.object),
  onFilter: PropTypes.func,
  onColumnFilter: PropTypes.func,
  filterPlaceholder: intlMessageShape,
  children: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  multipleRowsExpandable: PropTypes.bool,
  renderExpanderContent: PropTypes.func,
  headerMultiline: PropTypes.bool,
  onRowClick: PropTypes.func,
  expandOnRowClick: PropTypes.bool,
  selectOnRowClick: PropTypes.bool,
  selectionType: PropTypes.oneOf(['none', 'single', 'multi']),
  selectedRows: PropTypes.arrayOf(rowIdShape),
  selectionActions: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired
  })),
  onSelectionChange: PropTypes.func,
  columnsConfigurable: PropTypes.bool,
  loadingText: intlMessageShape,
  noDataText: intlMessageShape,
  localSorting: PropTypes.bool,
  phone: PropTypes.object,
  phoneWide: PropTypes.object,
  tablet: PropTypes.object,
  onSaveRow: PropTypes.func,
  onEditCancel: PropTypes.func,
  onEditStart: PropTypes.func,
  path: PropTypes.string,
  onFetchData: PropTypes.func,
  onGetRowId: PropTypes.func,
  rowIdPath: PropTypes.string,
  tableLabel: intlMessageShape,
  numberOfRows: PropTypes.number
};
export var DataTable = function DataTable(dataTableProps) {
  var _useBreakpoint = useBreakpoint(dataTableProps),
      breakpointProps = _useBreakpoint.breakpointProps,
      applyBreakpoint = _useBreakpoint.applyBreakpoint,
      breakpoint = _useBreakpoint.breakpoint;

  var id = breakpointProps.id,
      showSearch = breakpointProps.showSearch,
      showPagination = breakpointProps.showPagination,
      pageSizeOptions = breakpointProps.pageSizeOptions,
      syncData = breakpointProps.data,
      onFilter = breakpointProps.onFilter,
      onColumnFilter = breakpointProps.onColumnFilter,
      defaultConfig = breakpointProps.defaultConfig,
      config = breakpointProps.config,
      filterPlaceholder = breakpointProps.filterPlaceholder,
      children = breakpointProps.children,
      onConfigChange = breakpointProps.onConfigChange,
      onSaveRow = breakpointProps.onSaveRow,
      onEditCancel = breakpointProps.onEditCancel,
      onEditStart = breakpointProps.onEditStart,
      expandable = breakpointProps.expandable,
      multipleRowsExpandable = breakpointProps.multipleRowsExpandable,
      renderExpanderContent = breakpointProps.renderExpanderContent,
      basePath = breakpointProps.path,
      headerMultiline = breakpointProps.headerMultiline,
      onRowClick = breakpointProps.onRowClick,
      expandOnRowClick = breakpointProps.expandOnRowClick,
      selectOnRowClick = breakpointProps.selectOnRowClick,
      selectionType = breakpointProps.selectionType,
      onGetRowIdProp = breakpointProps.onGetRowId,
      rowIdPath = breakpointProps.rowIdPath,
      selectedRows = breakpointProps.selectedRows,
      selectionActions = breakpointProps.selectionActions,
      onSelectionChange = breakpointProps.onSelectionChange,
      onFetchData = breakpointProps.onFetchData,
      columnsConfigurable = breakpointProps.columnsConfigurable,
      loadingText = breakpointProps.loadingText,
      noDataText = breakpointProps.noDataText,
      localSorting = breakpointProps.localSorting,
      tableLabel = breakpointProps.tableLabel,
      numberOfRowsProp = breakpointProps.numberOfRows;
  var onGetRowId = useMemo(function () {
    return rowIdPath ? function (row) {
      return row[rowIdPath];
    } : onGetRowIdProp;
  }, [onGetRowIdProp, rowIdPath]);
  var childrenArray = React.Children.toArray(children);
  var reactTable = useRef();
  var shouldShowSearch = showSearch !== false;
  var shouldShowPagination = showPagination !== false;
  var shouldBeExpandable = expandable && !!renderExpanderContent;
  var shouldBeSelectable = selectionType !== 'none';
  var translator = useContext(TranslatorContext);
  var language = LocaleService.getStoredLanguage();

  var _useExpansion = useExpansion(),
      _useExpansion2 = _slicedToArray(_useExpansion, 2),
      expandedRows = _useExpansion2[0],
      _useExpansion2$ = _useExpansion2[1],
      collapse = _useExpansion2$.collapse,
      toggleExpansion = _useExpansion2$.toggle,
      collapseAll = _useExpansion2$.collapseAll;

  var _useSelection = useSelection({
    all: false,
    rows: selectedRows || []
  }, selectedRows, selectionType, onSelectionChange),
      _useSelection2 = _slicedToArray(_useSelection, 2),
      selectedState = _useSelection2[0],
      _useSelection2$ = _useSelection2[1],
      selectRow = _useSelection2$.select,
      toggleSelection = _useSelection2$.toggle,
      setAll = _useSelection2$.setAll,
      clearAll = _useSelection2$.clearAll;

  var _useAsync = useAsync(),
      _useAsync2 = _slicedToArray(_useAsync, 2),
      _useAsync2$ = _useAsync2[0],
      asyncData = _useAsync2$.asyncData,
      loading = _useAsync2$.loading,
      totalNumberOfRows = _useAsync2$.numberOfRows,
      asyncActions = _useAsync2[1];

  var data = onFetchData ? asyncData : syncData;

  var getEditProps = function getEditProps(rowId) {
    return rowId !== undefined ? {
      rowId: rowId,
      row: _findInstanceProperty(data).call(data, function (row, index) {
        return onGetRowId(row, index) === rowId;
      })
    } : {};
  };

  var _useState = useState(getEditProps((config === null || config === void 0 ? void 0 : config.editedRow) || defaultConfig.editedRow)),
      _useState2 = _slicedToArray(_useState, 2),
      editProps = _useState2[0],
      setEditProps = _useState2[1];

  var updateEditedRow = function updateEditedRow(rowId) {
    return setEditProps(getEditProps(rowId));
  };

  var initialColumnsConfig = useMemo(function () {
    var _config$columns, _context;

    var initialConfig = (_config$columns = config === null || config === void 0 ? void 0 : config.columns) !== null && _config$columns !== void 0 ? _config$columns : defaultConfig.columns;
    var withInitialConfig = initialConfig === null || initialConfig === void 0 ? void 0 : initialConfig.length;

    if (!childrenArray.length) {
      return [];
    }

    if (withInitialConfig) {
      _sortInstanceProperty(childrenArray).call(childrenArray, orderColumnsUsingConfig(initialConfig));
    }

    return _filterInstanceProperty(_context = _mapInstanceProperty(childrenArray).call(childrenArray, function (childColumn) {
      var columnChildId = childColumn.props.id,
          type = childColumn.type;

      if (_includesInstanceProperty(nonConfigurableColumns).call(nonConfigurableColumns, type)) {
        return undefined;
      }

      var columnConfig = {
        id: columnChildId,
        enabled: true
      };

      if (withInitialConfig) {
        var initialColumnConfig = _findInstanceProperty(initialConfig).call(initialConfig, function (_ref4) {
          var configId = _ref4.id;
          return columnChildId === configId;
        });

        columnConfig.enabled = isEnabledColumn(initialColumnConfig);
      }

      return columnConfig;
    })).call(_context, Boolean);
  }, [childrenArray, config, defaultConfig]);

  var _useConfig = useConfig(_objectSpread({}, defaultConfig, {
    columns: initialColumnsConfig
  }), config && function () {
    if (config.editedRow !== (editProps === null || editProps === void 0 ? void 0 : editProps.rowId)) {
      updateEditedRow(config.editedRow);
    }

    return _objectSpread({}, config, {
      columns: initialColumnsConfig
    });
  }, onConfigChange),
      _useConfig2 = _slicedToArray(_useConfig, 2),
      _useConfig2$ = _useConfig2[0],
      filterValue = _useConfig2$.filterValue,
      pageSizeSelectedOption = _useConfig2$.pageSize,
      page = _useConfig2$.page,
      sorted = _useConfig2$.sorted,
      columns = _useConfig2$.columns,
      editedRow = _useConfig2$.editedRow,
      _useConfig2$2 = _useConfig2[1],
      setFilterValue = _useConfig2$2.setFilterValue,
      setPageSize = _useConfig2$2.setPageSize,
      setPage = _useConfig2$2.setPage,
      setSorted = _useConfig2$2.setSorted,
      setColumns = _useConfig2$2.setColumns,
      setEditedRow = _useConfig2$2.setEditedRow;

  var _useAccessibilityProp = useAccessibilityProps({
    selectionType: selectionType,
    isExpandable: expandable && renderExpanderContent,
    tableId: id,
    sorted: sorted,
    tableLabel: translator(tableLabel)
  }),
      getA11yTrGroupProps = _useAccessibilityProp.getA11yTrGroupProps,
      getA11yTrProps = _useAccessibilityProp.getA11yTrProps,
      getA11yTableProps = _useAccessibilityProp.getA11yTableProps,
      getA11yTheadThPropsHeader = _useAccessibilityProp.getA11yTheadThPropsHeader,
      getA11yTheadThPropsSortableHeader = _useAccessibilityProp.getA11yTheadThPropsSortableHeader,
      getA11yTdProps = _useAccessibilityProp.getA11yTdProps;

  var isEdited = useCallback(function (rowId) {
    return editedRow === rowId;
  }, [editedRow]);
  var editActions = {
    start: function start(row, index) {
      var rowId = onGetRowId(row, index);

      if (onEditStart) {
        onEditStart(row, rowId);
      }

      setEditedRow(rowId);
      updateEditedRow(rowId);
      collapse(rowId);
    },
    update: function update(_row, path, newValue) {
      setEditProps(function (oldEditProps) {
        return _objectSpread({}, oldEditProps, {
          row: _objectSpread({}, oldEditProps.row, _defineProperty({}, path, newValue))
        });
      });
    },
    cancel: function cancel() {
      if (onEditCancel) {
        onEditCancel(editProps.row, editProps.rowId);
      }

      setEditedRow();
      updateEditedRow();
    },
    save: function save() {
      if (onSaveRow) {
        onSaveRow(editProps.row, editProps.rowId);
      }

      setEditedRow();
      updateEditedRow();
    }
  };

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      pressedRowId = _useState4[0],
      setPressedRowId = _useState4[1];

  var handleExpand = useCallback(function (rowId, viewIndex) {
    return !isEdited(rowId) && toggleExpansion(rowId, viewIndex, multipleRowsExpandable);
  }, [isEdited, multipleRowsExpandable, toggleExpansion]);
  var filterFunction = useMemo(function () {
    if (onFilter) {
      return onFilter;
    }

    return function (value) {
      var valueFilters = _mapInstanceProperty(childrenArray).call(childrenArray, function (_ref5) {
        var props = _ref5.props;
        return (props.onFilter || onColumnFilter)(value, props);
      });

      return function (item, index, tableData) {
        return _someInstanceProperty(valueFilters).call(valueFilters, function (valueFilter) {
          return valueFilter(item, index, tableData);
        });
      };
    };
  }, [onFilter, childrenArray, onColumnFilter]);
  var contextColumnsConfig = useMemo(function () {
    return _mapInstanceProperty(columns).call(columns, function (columnConfig) {
      var childColumn = _findInstanceProperty(childrenArray).call(childrenArray, function (_ref6) {
        var columnChildId = _ref6.props.id;
        return columnConfig.id === columnChildId;
      });

      return _objectSpread({}, columnConfig, {
        header: childColumn.props.header
      });
    });
  }, [childrenArray, columns]);
  var tableContext = useMemo(function () {
    return {
      styles: styles,
      columns: _objectSpread({
        configurable: columnsConfigurable,
        config: contextColumnsConfig
      }, columnsConfigurable && {
        setConfig: setColumns
      })
    };
  }, [columnsConfigurable, contextColumnsConfig, setColumns]);
  var filteredData = useMemo(function () {
    if (!data || !children) return [];
    return shouldShowSearch && filterValue ? _filterInstanceProperty(data).call(data, filterFunction(filterValue)) : data;
  }, [shouldShowSearch, data, children, filterFunction, filterValue]);
  var numberOfRows = onFetchData ? totalNumberOfRows : numberOfRowsProp || filteredData.length;
  var pageSize = useMemo(function () {
    return !shouldShowPagination || pageSizeSelectedOption === SHOW_ALL_PAGES ? numberOfRows : pageSizeSelectedOption;
  }, [shouldShowPagination, pageSizeSelectedOption, numberOfRows]);
  var Expander = useCallback(function (_ref7) {
    var isExpanded = _ref7.isExpanded,
        row = _ref7.row,
        index = _ref7.index,
        viewIndex = _ref7.viewIndex;
    return React.createElement(Chevron, {
      isOpen: isExpanded,
      className: styles.expanderIcon,
      tabIndex: "0",
      role: "button",
      messageProps: {
        label: !isExpanded ? messages.collapsedRowLabel : messages.expandedRowLabel
      },
      onMouseDown: function onMouseDown(event) {
        event.preventDefault();
      },
      onKeyPress: getKeyPressHandler(function () {
        return toggleExpansion(onGetRowId(row, index), viewIndex, multipleRowsExpandable);
      })
    });
  }, [toggleExpansion, multipleRowsExpandable, onGetRowId]);
  var getExpandRowActions = useCallback(function (_ref8) {
    var index = _ref8.index,
        viewIndex = _ref8.viewIndex,
        row = _ref8.row;
    return shouldBeExpandable && expandOnRowClick && function () {
      return handleExpand(onGetRowId(row, index), viewIndex);
    };
  }, [expandOnRowClick, handleExpand, shouldBeExpandable, onGetRowId]);
  var SelectionHeader = useMemo(function () {
    if (selectionType !== 'multi') {
      return undefined;
    }

    return function () {
      return React.createElement(CheckboxField, {
        id: "".concat(id, "-select-all"),
        onValueChange: function onValueChange(value) {
          if (value) {
            var _context2;

            var allRows = reactTable.current.getResolvedState().sortedData;
            var startIndex = page * pageSize;

            var visibleRows = _mapInstanceProperty(_context2 = _sliceInstanceProperty(allRows).call(allRows, startIndex, startIndex + pageSize)).call(_context2, function (_ref9) {
              var _original = _ref9._original,
                  _index = _ref9._index;
              return onGetRowId(_original, _index);
            });

            setAll(visibleRows);
          } else {
            clearAll();
          }
        },
        value: selectedState.all
      });
    };
  }, [id, pageSize, page, selectionType, selectedState.all, clearAll, setAll, onGetRowId]);
  var SelectionCell = useMemo(function () {
    if (selectionType === 'none') {
      return undefined;
    }

    if (selectionType === 'single') {
      return function (_ref10) {
        var index = _ref10.index,
            viewIndex = _ref10.viewIndex,
            row = _ref10.original;
        var rowId = onGetRowId(row, index);
        return React.createElement(RadioButton, {
          id: "".concat(id, "-select-").concat(viewIndex),
          option: {
            code: rowId
          },
          onValueChange: function onValueChange() {
            return selectRow(rowId);
          },
          value: "".concat(selectedState.rows[0]),
          className: styles.radio,
          tabIndex: "0"
        });
      };
    }

    return function (_ref11) {
      var index = _ref11.index,
          viewIndex = _ref11.viewIndex,
          row = _ref11.original;

      var _context3;

      var rowId = onGetRowId(row, index);
      return React.createElement(CheckboxField, {
        id: "".concat(id, "-select-").concat(viewIndex),
        onValueChange: function onValueChange() {
          return toggleSelection(rowId);
        },
        value: _includesInstanceProperty(_context3 = selectedState.rows).call(_context3, rowId)
      });
    };
  }, [id, selectionType, selectedState.rows, selectRow, toggleSelection, onGetRowId]);
  var shouldDisableActions = selectedState.rows.length > 1;
  var columnsArray = useMemo(function () {
    var _context5;

    var visibleColumns = childrenArray;

    if (columns !== null && columns !== void 0 && columns.length) {
      var _context4;

      visibleColumns = _sortInstanceProperty(_context4 = _filterInstanceProperty(visibleColumns).call(visibleColumns, function (_ref12) {
        var colId = _ref12.props.id;

        var _columnConfig$enabled;

        var columnConfig = _findInstanceProperty(columns).call(columns, function (_ref13) {
          var configId = _ref13.id;
          return colId === configId;
        });

        return (_columnConfig$enabled = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.enabled) !== null && _columnConfig$enabled !== void 0 ? _columnConfig$enabled : true;
      })).call(_context4, orderColumnsUsingConfig(columns));
    }

    var childrenColumns = _mapInstanceProperty(visibleColumns).call(visibleColumns, function (_ref14, columnIndex) {
      var props = _ref14.props,
          type = _ref14.type;

      var _applyBreakpoint = applyBreakpoint(props),
          cell = _applyBreakpoint.cell,
          renderCell = _applyBreakpoint.renderCell,
          renderEditCell = _applyBreakpoint.renderEditCell,
          getRowActions = _applyBreakpoint.getRowActions,
          columnClassName = _applyBreakpoint.columnClassName,
          rest = _objectWithoutProperties(_applyBreakpoint, ["cell", "renderCell", "renderEditCell", "getRowActions", "columnClassName"]);

      var childId = rest.id,
          header = rest.header,
          renderHeader = rest.renderHeader,
          textAlign = rest.textAlign,
          visible = rest.visible,
          headerClassName = rest.headerClassName,
          cellClassName = rest.cellClassName,
          columnProportion = rest.columnProportion,
          width = rest.width,
          sortable = rest.sortable,
          readOnly = rest.readOnly,
          editCellClass = rest.editCellClass,
          path = rest.path,
          onSort = rest.onSort,
          onAccessor = rest.onAccessor;

      if ((type === null || type === void 0 ? void 0 : type.name) === 'MoneyColumn') {
        logDeprecationMessage('MoneyColumn', 'DisplayColumn with [fieldDatatype="currency"]', undefined, '6.0.0');
      }

      var cellCallback = cell || renderCell;
      var editCellCallback = renderEditCell;

      var propsToCallback = _objectSpread({}, rest, {
        basePath: basePath,
        translator: translator,
        disableActions: shouldDisableActions,
        breakpoint: breakpoint
      });

      var Cell = cellCallback && function (_ref15) {
        var original = _ref15.original,
            index = _ref15.index;
        var rowId = onGetRowId(original, index);

        if (!readOnly && editCellCallback && isEdited(rowId)) {
          return editCellCallback({
            props: propsToCallback,
            editProps: _objectSpread({}, editProps, {
              index: index
            }),
            editActions: editActions
          });
        }

        return cellCallback(original, rowId, propsToCallback, editActions.start);
      };

      var headerText = translator(header);
      var headerFunction = renderHeader || (headerMultiline ? splitHeaderText : _.identity);
      var columnType = (type === null || type === void 0 ? void 0 : type.name) === 'ActionColumn' ? 'actions' : 'display';
      return {
        id: childId || columnIndex,
        type: columnType,
        Header: function Header() {
          return headerFunction(headerText);
        },
        Cell: Cell,
        className: cx(textAlignMapping[textAlign], columnClassName, cellClassName),
        headerClassName: cx(textAlignMapping[textAlign], _defineProperty({}, styles.headerOneLine, !headerMultiline), headerClassName),
        show: visible === undefined ? true : visible,
        minWidth: columnProportion,
        width: width,
        sortable: sortable,
        readOnly: readOnly,
        editCellClass: editCellClass,
        textAlign: textAlign,
        accessor: onAccessor || path,
        header: headerText,
        getRowActions: getRowActions,
        props: rest,
        sortMethod: onSort
      };
    });

    var selectionClassName = cx(styles.selectionCell, _defineProperty({}, styles.serviceCell, shouldBeExpandable));
    var selectionWidth = 44;
    var expanderClassName = cx(styles.expanderCell, _defineProperty({}, styles.serviceCell, shouldBeSelectable));
    var expanderWidth = 28;

    var serviceColumns = _filterInstanceProperty(_context5 = [shouldBeSelectable && {
      id: 'selection',
      type: "".concat(selectionType, "_selection"),
      Header: SelectionHeader,
      Cell: SelectionCell,
      sortable: false,
      resizable: false,
      minWidth: selectionWidth,
      width: selectionWidth,
      textAlign: 'center',
      headerClassName: selectionClassName,
      className: selectionClassName
    }, shouldBeExpandable && {
      id: 'expander',
      type: 'expander',
      expander: true,
      readOnly: true,
      getRowActions: getExpandRowActions,
      Expander: Expander,
      className: expanderClassName,
      isEdited: isEdited,
      width: expanderWidth,
      minWidth: expanderWidth
    }]).call(_context5, Boolean);

    return _concatInstanceProperty(serviceColumns).call(serviceColumns, childrenColumns);
  }, [childrenArray, columns, shouldBeExpandable, shouldBeSelectable, SelectionHeader, SelectionCell, getExpandRowActions, Expander, isEdited, applyBreakpoint, basePath, shouldDisableActions, breakpoint, translator, headerMultiline, editActions, editProps, onGetRowId]);
  var getTrProps = useCallback(function (item, row) {
    var _cx4;

    var _context6, _context7;

    var rowColumns = item.columns;
    var original = row.original,
        index = row.index,
        viewIndex = row.viewIndex;

    var rowClickAction = onRowClick && function (event) {
      return onRowClick(original, index, event);
    };

    var availableActions = _filterInstanceProperty(_context6 = _.flatten([rowClickAction].concat(_toConsumableArray(_mapInstanceProperty(rowColumns).call(rowColumns, function (_ref16) {
      var getRowActions = _ref16.getRowActions,
          props = _ref16.props;
      return getRowActions && getRowActions({
        row: original,
        index: index,
        viewIndex: viewIndex,
        props: props,
        onEditStart: editActions.start,
        selectOnRowClick: selectOnRowClick,
        expandOnRowClick: expandOnRowClick
      });
    }))))).call(_context6, Boolean);

    var rowId = onGetRowId(original, index);
    var hasActions = availableActions.length;
    var isRowPressed = pressedRowId === rowId;

    var isRowSelected = _includesInstanceProperty(_context7 = selectedState.rows).call(_context7, rowId);

    var isRowEdited = isEdited(rowId);

    var actionsHandler = function actionsHandler(event) {
      if (event.target === event.currentTarget) {
        event.preventDefault();
      }

      _forEachInstanceProperty(availableActions).call(availableActions, function (action) {
        return handleNestedClick(event, action);
      });
    };

    var getRowPressHandler = function getRowPressHandler(callback) {
      return function (event) {
        if (event.key !== ' ' && event.key !== 'Enter') {
          return;
        }

        handleNestedClick(event, callback);
      };
    };

    var props = _objectSpread({
      hasActions: hasActions,
      className: cx(styles.tableRow, (_cx4 = {}, _defineProperty(_cx4, styles.clickableRow, hasActions), _defineProperty(_cx4, styles.activeRow, isRowPressed), _defineProperty(_cx4, styles.selectedRow, isRowSelected), _defineProperty(_cx4, styles.editedRow, isRowEdited), _cx4))
    }, getA11yTrProps());

    if (hasActions) {
      props.onClick = actionsHandler;
      props.onKeyPress = getRowPressHandler(actionsHandler);
      props.onKeyDown = getRowPressHandler(function () {
        return pressedRowId !== rowId && setPressedRowId(rowId);
      });
      props.onKeyUp = getRowPressHandler(function () {
        return setPressedRowId(null);
      });
    }

    return props;
  }, [editActions.start, expandOnRowClick, onRowClick, pressedRowId, selectOnRowClick, selectedState.rows, onGetRowId, getA11yTrProps, isEdited]);
  var getTdProps = useCallback(function (state, row, _ref17) {
    var _cx5;

    var readOnly = _ref17.readOnly,
        textAlign = _ref17.textAlign,
        editCellClass = _ref17.editCellClass,
        type = _ref17.type,
        columnId = _ref17.id;
    var index = row.index,
        viewIndex = row.viewIndex,
        original = row.original;
    var rowId = onGetRowId(original, index);
    var edited = isEdited(rowId);
    var isExpander = type === 'expander';
    var shouldBeFocusable = type !== 'display';
    return _objectSpread({
      className: cx(styles.tableCell, (_cx5 = {}, _defineProperty(_cx5, editCellClass, editCellClass && !readOnly && edited), _defineProperty(_cx5, styles.rightAlignCell, textAlign === 'right'), _defineProperty(_cx5, "disabled", isExpander && edited), _cx5)),
      onClick: isExpander && function () {
        return handleExpand(rowId, viewIndex);
      }
    }, getA11yTdProps(state, row, columnId, shouldBeFocusable));
  }, [isEdited, handleExpand, onGetRowId, getA11yTdProps]);
  var getHeaderCellProps = useCallback(function (_props, _columnInfo, column) {
    var sortable = column.sortable === undefined || column.sortable;
    var sharedProps = {
      className: cx(styles.tableHeaderCell, _defineProperty({}, styles.unsortedHeaderCell, !sortable)),
      title: column.header
    };

    if (sortable) {
      return _objectSpread({}, sharedProps, {}, getA11yTheadThPropsSortableHeader(_props, column.id, column.type));
    }

    return _objectSpread({}, sharedProps, {
      pointerEvents: 'none'
    }, getA11yTheadThPropsHeader(_props, column.id, column.type));
  }, [getA11yTheadThPropsSortableHeader, getA11yTheadThPropsHeader]);
  var defaultSortMethod = useCallback(function (a, b) {
    var sortingFunction = sortWithLocale(language);
    return sortingFunction(normalize(a), normalize(b));
  }, [language]);
  var tbodyProps = numberOfRows === 0 && {
    TbodyComponent: function TbodyComponent() {
      return React.createElement("div", {
        className: styles.noDataMessage
      }, translator(noDataText));
    }
  };
  var handleAsyncDataChange = useCallback(function _callee(asyncConfigs) {
    var _reactTable$current, setAsyncData, setLoading, reactTableState, asyncParams, fetchedData;

    return _regeneratorRuntime.async(function _callee$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            setAsyncData = asyncActions.setAsyncData, setLoading = asyncActions.setLoading;
            reactTableState = reactTable === null || reactTable === void 0 ? void 0 : (_reactTable$current = reactTable.current) === null || _reactTable$current === void 0 ? void 0 : _reactTable$current.state;
            asyncParams = _objectSpread({}, getAsyncParams(reactTableState), {}, getAsyncParams(asyncConfigs));

            if (asyncParams.page !== undefined) {
              setPage(asyncParams.page);
            }

            _context8.prev = 4;
            setLoading(true);
            _context8.next = 8;
            return _regeneratorRuntime.awrap(onFetchData(asyncParams));

          case 8:
            fetchedData = _context8.sent;
            setAsyncData(fetchedData.rows, fetchedData.numberOfRows);
            _context8.next = 15;
            break;

          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](4);
            error("Failed to fetch data, ".concat(_context8.t0));

          case 15:
            _context8.prev = 15;
            setLoading(false);
            return _context8.finish(15);

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, null, null, [[4, 12, 15, 18]], Promise);
  }, [asyncActions, onFetchData]);
  var debounceFilter = useCallback(_.debounce(function (newFilterValue) {
    handleAsyncDataChange({
      filterValue: newFilterValue,
      page: 0
    });
  }, 500), [handleAsyncDataChange]);
  var modeProps = onFetchData ? {
    data: data,
    loading: loading,
    filterValue: filterValue,
    loadingText: translator(loadingText)
  } : {
    sorted: sorted,
    defaultSortMethod: defaultSortMethod,
    page: page
  };
  var isSortedOnServer = onFetchData && !localSorting;
  var isControlledMode = !onFetchData && numberOfRowsProp !== undefined;
  var handleSortedChange = useCallback(function (newSortedValue) {
    setSorted(newSortedValue, isSortedOnServer || isControlledMode);
    collapseAll();

    if (isSortedOnServer) {
      handleAsyncDataChange({
        sorted: newSortedValue,
        page: 0
      });
    }
  }, [setSorted, isSortedOnServer, collapseAll, handleAsyncDataChange]);
  var handlePageChange = useCallback(function (newPage) {
    setPage(newPage);
    collapseAll();

    if (onFetchData) {
      handleAsyncDataChange({
        page: newPage
      });
    }
  }, [setPage, collapseAll, onFetchData, handleAsyncDataChange]);
  var getPaginationComponent = useCallback(function () {
    var _uniqueInnerId = uniqueInnerId(id, 'paginationId'),
        paginationId = _uniqueInnerId.paginationId;

    var handleSelectPageSizeChange = function handleSelectPageSizeChange(value) {
      var newPageSize = value === SHOW_ALL_PAGES ? value : Number(value);
      setPageSize(newPageSize, true);
      collapseAll();

      if (onFetchData) {
        handleAsyncDataChange({
          page: 0,
          pageSize: newPageSize
        });
      }
    };

    return React.createElement(Pagination, {
      id: "".concat(paginationId, "_pagination"),
      numberOfRows: numberOfRows,
      pageSize: pageSize,
      pageSizeOptions: pageSizeOptions,
      pageSizeSelectedOption: pageSizeSelectedOption,
      onSelectPageSizeChange: handleSelectPageSizeChange,
      page: page,
      onPageChange: handlePageChange,
      canNext: page < Math.ceil(numberOfRows / pageSize) - 1,
      canPrevious: page !== 0
    });
  }, [collapseAll, handleAsyncDataChange, handlePageChange, id, numberOfRows, onFetchData, page, pageSize, pageSizeOptions, pageSizeSelectedOption, setPageSize]);
  var paginationProps = shouldShowPagination && numberOfRows > 0 ? {
    defaultPageSize: defaultConfig.pageSize,
    PaginationComponent: getPaginationComponent,
    showPageJump: true,
    showPaginationTop: true,
    showPaginationBottom: false
  } : {
    showPagination: false,
    pageSize: numberOfRows
  };
  var expanderContentWrapper = useCallback(function (_ref18) {
    var rowData = _ref18.original;
    var expanderContentWrapperStyles = cx(styles.expandableRowWrapper, styles.expandableRow);
    return React.createElement(AnimationGroup, {
      animation: "expand",
      appear: true,
      in: true
    }, React.createElement("div", {
      className: expanderContentWrapperStyles
    }, renderExpanderContent(rowData)));
  }, [renderExpanderContent]);
  var subComponent = shouldBeExpandable ? expanderContentWrapper : null;
  var renderTableBar = useCallback(function () {
    var handleFilterChange = function handleFilterChange(newFilterValue) {
      setFilterValue(newFilterValue, true);

      if (onFetchData) {
        debounceFilter(newFilterValue);
      }

      collapseAll();
    };

    var actions = selectionActions === null || selectionActions === void 0 ? void 0 : _mapInstanceProperty(selectionActions).call(selectionActions, function (_ref19) {
      var _callback = _ref19.callback,
          rest = _objectWithoutProperties2(_ref19, ["callback"]);

      return _objectSpread({}, rest, {
        callback: function callback() {
          _callback(selectedState.rows);

          clearAll();
        }
      });
    });
    return React.createElement(TableContext.Provider, {
      value: tableContext
    }, React.createElement(TableBar, {
      filterValue: filterValue,
      onFilterChange: handleFilterChange,
      filterPlaceholder: translator(filterPlaceholder),
      selectionActions: actions,
      showSelectionActions: !!selectedState.rows.length,
      disabled: loading
    }));
  }, [debounceFilter, filterPlaceholder, filterValue, clearAll, loading, onFetchData, selectedState.rows, selectionActions, setFilterValue, tableContext, translator, collapseAll]);
  var reactTableKey = "".concat(id, "_").concat(onFetchData ? 'async' : 'sync');
  var getStyleProps = useCallback(function () {
    return _.mapValues({
      getTheadProps: styles.tableHeader,
      getTbodyProps: styles.tableBody,
      getTrGroupProps: styles.tableRowGroup
    }, function (className) {
      return function () {
        return _objectSpread({
          className: className
        }, getA11yTrGroupProps());
      };
    });
  }, [getA11yTrGroupProps]);
  useEffect(function () {
    if (!onFetchData && numberOfRowsProp === undefined) {
      var isFirstPage = page === 0;
      var isLastPage = page === Math.floor(filteredData.length / pageSize);
      var isPageEmpty = isLastPage && filteredData.length % pageSize === 0;

      if (!isFirstPage && isPageEmpty) {
        setPage(page - 1);
      }
    }
  }, [pageSize, page, onFetchData, setPage, filteredData, numberOfRowsProp]);
  useEffect(function () {
    if (onFetchData) {
      if (syncData || numberOfRowsProp) {
        warning('The props `data` and `numberOfRows` will not be used when `onFetchData` prop is provided');
      }

      var updatedConfig = defaultConfig;

      if (pageSize !== undefined) {
        updatedConfig.pageSize = pageSize;
      }

      handleAsyncDataChange(updatedConfig);
    }
  }, [handleAsyncDataChange, onFetchData, syncData, numberOfRowsProp, defaultConfig]);
  return React.createElement("div", {
    id: id,
    className: styles.dataTable
  }, shouldShowSearch && renderTableBar(), React.createElement(ReactTable, _extends({
    key: reactTableKey,
    ref: reactTable,
    data: filteredData,
    columns: columnsArray,
    getTheadThProps: getHeaderCellProps,
    minRows: 0,
    styles: styles,
    className: cx(styles.reactTable, '-striped', '-highlight'),
    SubComponent: subComponent,
    expanded: expandedRows
  }, paginationProps, getStyleProps(), tbodyProps, {
    getTdProps: getTdProps,
    getTrProps: getTrProps,
    getTheadTrProps: getA11yTrProps,
    getTableProps: function getTableProps() {
      return getA11yTableProps;
    },
    NoDataComponent: renderNull,
    expanderDefaults: expanderDefaults,
    TrGroupComponent: AnimatedTrGroupComponent,
    TrComponent: AnimationResistantTrComponent,
    defaultSorted: defaultConfig.sorted,
    pageSize: pageSize,
    onPageChange: handlePageChange,
    onSortedChange: handleSortedChange
  }, modeProps, {
    manual: isSortedOnServer || isControlledMode
  })));
};
DataTable.propTypes = dataTablePropTypes;
DataTable.defaultProps = {
  showSearch: true,
  showPagination: true,
  defaultConfig: {
    filterValue: '',
    page: 0,
    pageSize: 10
  },
  onColumnFilter: defaultColumnFilter,
  pageSizeOptions: [10, 25, 50],
  expandable: true,
  multipleRowsExpandable: true,
  headerMultiline: false,
  selectionType: 'none',
  columnsConfigurable: true,
  noDataText: messages.noDataText,
  loadingText: messages.loadingText,
  localSorting: false,
  onGetRowId: function onGetRowId(row, index) {
    return index;
  },
  tableLabel: messages.tableLabel,
  filterPlaceholder: messages.searchPlaceholder
};

function normalize(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return value;
}

AnimatedTrGroupComponent.__docgenInfo = {
  componentName: "AnimatedTrGroupComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimatedTrGroupComponent",
  methods: [],
  actualName: "AnimatedTrGroupComponent"
};
AnimationResistantTrComponent.__docgenInfo = {
  componentName: "AnimationResistantTrComponent",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "AnimationResistantTrComponent",
  methods: [],
  actualName: "AnimationResistantTrComponent"
};
splitHeaderText.__docgenInfo = {
  componentName: "splitHeaderText",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "splitHeaderText",
  methods: [],
  actualName: "splitHeaderText"
};
DataTable.__docgenInfo = {
  componentName: "DataTable",
  packageName: "@jutro/datatable",
  description: "Component for displaying tabular data",
  displayName: "DataTable",
  methods: [],
  actualName: "DataTable",
  metadataType: "container",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify the component"
    },
    showSearch: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether search bar should be shown",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    showPagination: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Defines whether pagination should be shown or not",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    config: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "Used to set data table config. Use it together with onConfigChange to control data table from outside.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting"
    },
    defaultConfig: {
      type: {
        name: "custom",
        raw: "dataTableConfigShape"
      },
      required: false,
      description: "The configuration applied only on component initialization.\nIt includes sorting method, filtering value, page, page size, edited row and columns sorting",
      defaultValue: {
        value: "{\n    filterValue: '',\n    page: 0,\n    pageSize: 10,\n}",
        computed: false
      }
    },
    onConfigChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Function to call after config value changes. New config value is passed as argument. It includes sorting method, filtering value, page, page size and columns visibility"
    },
    pageSizeOptions: {
      type: {
        name: "arrayOf",
        value: {
          name: "number"
        }
      },
      required: false,
      description: "List of page size options",
      defaultValue: {
        value: "[10, 25, 50]",
        computed: false
      }
    },
    data: {
      type: {
        name: "arrayOf",
        value: {
          name: "object"
        }
      },
      required: false,
      description: "Cells data"
    },
    onFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data"
    },
    onColumnFilter: {
      type: {
        name: "func"
      },
      required: false,
      description: "Predicate function for searching data per column",
      defaultValue: {
        value: "defaultColumnFilter",
        computed: true
      }
    },
    filterPlaceholder: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Placeholder text for search input",
      defaultValue: {
        value: "messages.searchPlaceholder",
        computed: true
      }
    },
    children: {
      type: {
        name: "node"
      },
      required: true,
      description: "Column of any type (e.g. DisplayColumn)"
    },
    expandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Possibility to make rows expandable",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    multipleRowsExpandable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Multiple rows can be expanded at the same time",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    renderExpanderContent: {
      type: {
        name: "func"
      },
      required: false,
      description: "Content of the expandable rows"
    },
    headerMultiline: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true header can be on 2 lines",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    onRowClick: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback for row click"
    },
    expandOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will expand on click"
    },
    selectOnRowClick: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Row will be selected on click"
    },
    selectionType: {
      type: {
        name: "enum",
        value: [{
          value: "'none'",
          computed: false
        }, {
          value: "'single'",
          computed: false
        }, {
          value: "'multi'",
          computed: false
        }]
      },
      required: false,
      description: "Configures row selection capability (none, single row, multi row)",
      defaultValue: {
        value: "'none'",
        computed: false
      }
    },
    selectedRows: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "rowIdShape"
        }
      },
      required: false,
      description: "Currently selected rows (passing value for this prop makes component fully controlled)"
    },
    selectionActions: {
      type: {
        name: "arrayOf",
        value: {
          name: "shape",
          value: {
            icon: {
              name: "string",
              required: true
            },
            label: {
              name: "string",
              required: true
            },
            callback: {
              name: "func",
              required: true
            }
          }
        }
      },
      required: false,
      description: "List of actions available for selection"
    },
    onSelectionChange: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when selection changed"
    },
    columnsConfigurable: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to false, end user will not have a possibility to customize visibility of columns",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    loadingText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text to show while data is loading, by default - 'Loading..'",
      defaultValue: {
        value: "messages.loadingText",
        computed: true
      }
    },
    noDataText: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Text message, when no data present to be shown",
      defaultValue: {
        value: "messages.noDataText",
        computed: true
      }
    },
    localSorting: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If set to true, sorting is happening locally after data is fetched\nOnly for async mode",
      defaultValue: {
        value: "false",
        computed: false
      }
    },
    phone: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'phone' breakpoint"
    },
    phoneWide: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use 'phoneWide' and 'phone' breakpoint"
    },
    tablet: {
      type: {
        name: "object"
      },
      required: false,
      description: "Include any DataTable property to use at 'tablet', 'phoneWide' and 'phone' breakpoint"
    },
    onSaveRow: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row is saved"
    },
    onEditCancel: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is canceled"
    },
    onEditStart: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row, rowId) to be invoked when row edit is started"
    },
    path: {
      type: {
        name: "string"
      },
      required: false,
      description: "The full path of view model, it also acts as an accessor for datatable's data"
    },
    onFetchData: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback to be invoked when new data has to be fetched in async mode,\nwith one argument of the current state of config object '{ filterValue, sorted, pageSize, page }'.\nShould return a promise of an object '{ rows, numberOfRows }', in which 'rows' is the filtered data to be presented for the current page,\n'numberOfRows' is the total length of whole data.\nIt takes precedence over `data` and `numberOfRows` sync props"
    },
    onGetRowId: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback (row) that returns unique id for the row.\nThe id should not change after editing the row.\nBy default index from data is used, but it does not work correctly when filtering.",
      defaultValue: {
        value: "(row, index) => index",
        computed: false
      }
    },
    rowIdPath: {
      type: {
        name: "string"
      },
      required: false,
      description: "Name of row object property containing the row id. Takes precedence over onGetRowId prop."
    },
    tableLabel: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Data table aria label",
      defaultValue: {
        value: "messages.tableLabel",
        computed: true
      }
    },
    numberOfRows: {
      type: {
        name: "number"
      },
      required: false,
      description: "Number of available rows"
    }
  }
};